import { Button } from "@/components/ui/button";
import type { QuizResult as QuizResultType } from "@/lib/api-types";
import { cn } from "@/lib/utils";
import { CheckCircle, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface QuizResultProps {
	result: QuizResultType;
	onRetry?: () => void;
}

export function QuizResult({ result, onRetry }: QuizResultProps) {
	const { t } = useTranslation();

	return (
		<div className="rounded-xl border border-white/10 bg-bg-elevated p-8 text-center">
			<div className="mb-4 flex justify-center">
				{result.passed ? (
					<CheckCircle className="h-16 w-16 text-success" />
				) : (
					<XCircle className="h-16 w-16 text-error" />
				)}
			</div>

			<h3 className={cn("mb-2 text-2xl font-bold", result.passed ? "text-success" : "text-error")}>
				{Math.round(result.score)}%
			</h3>

			<p className="mb-6 text-secondary">
				{result.passed ? t("quiz.passed") : t("quiz.failed", { score: result.passing_score })}
			</p>

			<p className="mb-6 text-sm text-muted">
				{t("course.passingScore", { score: result.passing_score })}
			</p>

			{!result.passed && onRetry && (
				<Button onClick={onRetry} variant="outline">
					{t("error.tryAgain")}
				</Button>
			)}
		</div>
	);
}
